(function() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  // This fix only makes sense on product pages (resetting the gallery to the
  // first slide after a variant swap). It was previously running globally,
  // and its MutationObserver was mistaking collection-page pagination
  // (which also calls history.replaceState) for a variant change, then
  // scrollIntoView-ing the first product card's slideshow on the page -
  // causing collection pages to jump back to the top while infinite-scrolling.
  if (!location.pathname.includes('/products/')) return;

  console.log("[Safari Gallery Fix] ✅ Script loaded for Safari");

  function initSafariGalleryFix() {
    console.log("[Safari Gallery Fix] initSafariGalleryFix() triggered...");

    function getSlideshow() {
      return document.querySelector('slideshow-component');
    }

    function resetGalleryToFirstSlide(slideshow) {
      if (!slideshow) return;
      console.log("[Safari Gallery Fix] → resetGalleryToFirstSlide() called");

      const slides = slideshow.querySelectorAll('slideshow-slide');
      if (!slides.length) {
        console.warn("[Safari Gallery Fix] ❌ No slides found.");
        return;
      }

      slides[0].scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
      console.log("[Safari Gallery Fix] ✅ Scrolled to first slide.");

      if (typeof slideshow.select === 'function') {
        slideshow.select(0);
        console.log("[Safari Gallery Fix] ✅ Used slideshow.select(0).");
      }

      console.log("[Safari Gallery Fix] Reset complete.");
    }

    // Watch for URL changes (variant changes)
    let lastUrl = location.href;
    new MutationObserver(() => {
      if (location.href !== lastUrl) {
        console.log("[Safari Gallery Fix] 🌐 URL changed:", location.href);
        lastUrl = location.href;

        // Wait for new slideshow to appear
        let retryCount = 0;
        const checkNewGallery = setInterval(() => {
          const newGallery = getSlideshow();
          if (newGallery) {
            console.log("[Safari Gallery Fix] 🆕 New slideshow detected — resetting now.");
            resetGalleryToFirstSlide(newGallery);
            clearInterval(checkNewGallery);
          } else if (retryCount++ > 10) {
            console.warn("[Safari Gallery Fix] ⚠️ New gallery not found after waiting.");
            clearInterval(checkNewGallery);
          }
        }, 300);
      }
    }).observe(document, { subtree: true, childList: true });

    console.log("[Safari Gallery Fix] ✅ Observer ready for variant changes.");
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSafariGalleryFix);
  } else {
    initSafariGalleryFix();
  }
})();
